export const scheduleQueryKeys = {
  all: ["schedule"] as const,
  upcomingLessons: () => [...scheduleQueryKeys.all, "upcomingLessons"] as const,
  student: (studentId: number, startDate: string, endDate: string) =>
    [
      ...scheduleQueryKeys.all,
      "student",
      studentId,
      startDate,
      endDate,
    ] as const,
  studentAllSchedule: () =>
    [...scheduleQueryKeys.all, "student", "allSchedule"] as const,
}
